/**
 * A directive for subsetting options.
 *
 * To implement this directive, follow this example:
 *
 * In your template:
 *
 * <tk-subsetting-options
 *    tk-web-project-card-model="controller.tkWebProjectCardModel"
 *    tk-web-project-family-card-model="controller.tkWebProjectFamilyCardModel">
 * </tk-subsetting-options>
 *
 * In your Javascript Controller:
 *
 * - tkWebProjectCardModel: The model which contains the details of the web project/kit.
 * - tkWebProjectFamilyCardModel: The model which contains the details of the tkff.
 *
 * @ngInject
 */
function Directive() {
  return {
    restrict: 'E',
    templateUrl: '/angular_templates/directives/tk_subsetting_options.html',
    scope: {},
    bindToController: {
      tkWebProjectCardModel: '=',
      tkWebProjectFamilyCardModel: '='
    },
    controller: require('./controller.js'),
    controllerAs: 'tkSubsettingOptionsCtrl'
  };
}

module.exports = Directive;
